import { defineStore } from "pinia";
import historialDeOfertasModel from "@/models/historialDeOfertasModel";
import usuarioModel from "@/models/usuarioModel";
import { alertError, showAlert } from "@/utils/alerts";
import { useUsuarioStore } from "@/store/usuarioStore";
import { reactive } from "vue";

export const usehistorialDeOfertasStore = defineStore(
  "historialDeOfertasStore",
  {
    state: () => ({
      cargandoHistorial: false,
      historial: [],
      datos_facturacion: [],
      selected_cuit: null,
      seleccionarTodo: false,
      selectAllCheck: false,
      selected_pujas: [],
      mostrarMovimientos: [],

      nombre_pestañas_menu: reactive([
        {
          id: 1,
          nombre_pestaña: "Todas",
          estado: "todas",
          busca_sin_datos: "No ofertas publicadas",
          listado: reactive([]),
          page: 1,
          last_page: 1,
        },
        {
          id: 2,
          nombre_pestaña: "Activas",
          estado: "en-subasta",
          busca_sin_datos: "No hay ofertas en ese estado",
          listado: reactive([]),
          page: 1,
          last_page: 1,
        },
        {
          id: 3,
          nombre_pestaña: "Aprobadas",
          estado: "vendido",
          busca_sin_datos: "No hay ofertas en ese estado",
          listado: [],
          page: 1,
          last_page: 1,
        },
        {
          id: 4,
          nombre_pestaña: "Desaprobadas",
          estado: "no-vendido",
          busca_sin_datos: "No hay ofertas en ese estado",
          listado: [],
          page: 1,
          last_page: 1,
        },
        {
          id: 5,
          nombre_pestaña: "Pendientes",
          estado: "en-negociacion",
          busca_sin_datos: "No hay ofertas en ese estado",
          listado: [],
          page: 1,
          last_page: 1,
        },
      ]),
      selected_tab: {
        id: 1,
        nombre_pestaña: "Todas",
        estado: "todas",
        busca_sin_datos: "No existe el lote con ese ID",
        listado: [],
        page: 1,
        last_page: 1,
      },
      id_busqueda: "",
      usuarioStore: useUsuarioStore(),
    }),

    actions: {
      async obtenerOfertasUsuario(
        estado,
        { page = 1, subasta_external_id = null } = {}
      ) {
        this.cargandoHistorial = true;
        try {
          const res = await historialDeOfertasModel.obtenerOfertasUsuario(
            estado,
            { page, subasta_external_id }
          );

          const listado = Array.isArray(res?.data?.data)
            ? res.data.data
            : Array.isArray(res?.data)
              ? res.data
              : [];
          const currentPage = Number(
            res?.current_page ??
              res?.data?.current_page ??
              res?.meta?.current_page ??
              page
          );
          const lastPage = Number(
            res?.last_page ?? res?.data?.last_page ?? res?.meta?.last_page ?? 1
          );

          const idx = this.nombre_pestañas_menu.findIndex(
            (t) => t.estado === estado
          );
          if (idx !== -1) {
            const tab = this.nombre_pestañas_menu[idx];

            const arr = Array.isArray(tab.listado)
              ? tab.listado
              : (tab.listado = []);
            arr.splice(0, arr.length, ...listado);
            tab.page = currentPage;
            tab.last_page = lastPage;

            if (this.selected_tab?.estado === estado) {
              const arr2 = Array.isArray(this.selected_tab.listado)
                ? this.selected_tab.listado
                : (this.selected_tab.listado = []);
              arr2.splice(0, arr2.length, ...listado);
              this.selected_tab.page = currentPage;
              this.selected_tab.last_page = lastPage;
            }
          }
        } catch (error) {
          console.error("obtenerOfertasUsuario()", error);
        } finally {
          this.selected_pujas = [];
          this.selectAllCheck = false;
          this.cargandoHistorial = false;
        }
      },

      async obtenerConjuntoOfertas() {
        await this.obtenerOfertasUsuario("todas");
        this.obtenerOfertasUsuario("en-subasta");
        this.obtenerOfertasUsuario("vendido");
        this.obtenerOfertasUsuario("no-vendido");
        this.obtenerOfertasUsuario("en-negociacion");
      },

      setSelectedTab(tab) {
        this.selected_tab = { ...tab };
        this.seleccionarTodo = false;
      },

      async obtenerPerfilesFacturacionUsuario() {
        try {
          const response =
            await usuarioModel.obtenerPerfilesFacturacionUsuario();
          this.datos_facturacion = Array.isArray(response.data)
            ? response.data
            : [];
        } catch (error) {
          console.error("obtenerPerfilesFacturacionUsuario()", error);
          this.datos_facturacion = [];
          alertError("No pudimos cargar tus perfiles de facturación");
        }
      },

      async asignarIdPerfilFacturacionALote(idLote, idFacturacion) {
        try {
          await historialDeOfertasModel.asignarIdPerfilFacturacionALote(
            idLote,
            idFacturacion
          );

          showAlert(
            "success",
            "Los datos fueron actualizados correctamente",
            2000
          );

          if (this.selected_tab.estado !== "todas") {
            this.obtenerOfertasUsuario("todas");
            this.obtenerOfertasUsuario(this.selected_tab.estado);
          } else {
            this.obtenerConjuntoOfertas();
          }
        } catch (error) {
          alertError("No se pudo asignar el perfil de facturación al lote");
        }
      },

      async asignarIdPerfilFacturacionALoteMasivo() {
        try {
          if (!this.selected_cuit) {
            alertError("Seleccione un CUIT antes de asignar");
            return;
          }
          const pujas = Array.from(this.selected_pujas);
          if (pujas.length === 0) {
            alertError("Debe seleccionar al menos un lote");
            return;
          }

          await historialDeOfertasModel.asignarIdPerfilFacturacionALoteMasivo(
            pujas,
            this.selected_cuit
          );

          if (this.selected_tab.estado !== "todas") {
            this.obtenerOfertasUsuario("todas");
            this.obtenerOfertasUsuario(this.selected_tab.estado);
          } else {
            this.obtenerConjuntoOfertas();
          }

          this.selected_pujas = [];
          this.selectAllCheck = false;

          showAlert(
            "success",
            "Los datos fueron actualizados correctamente",
            2000
          );

          this.obtenerConjuntoOfertas();
        } catch (error) {
          showAlert("error", "Error al actualizar los datos", 2000);
        }
      },

      toggleSelectAll() {
        if (this.selectAllCheck) {
          const ofertasVisibles = this.selected_tab?.listado ?? [];
          this.selected_pujas = ofertasVisibles
            .filter((puja) =>
              this.puedeMarcarCheckbox ? this.puedeMarcarCheckbox(puja) : true
            )
            .map((puja) => puja);
        } else {
          this.selected_pujas = [];
        }
      },

      toggleMostrarMovimientos(id) {
        const i = this.mostrarMovimientos.indexOf(id);
        if (i !== -1) this.mostrarMovimientos.splice(i, 1);
        else this.mostrarMovimientos.push(id);
      },

      esFinalizada(puja) {
        return puja.subasta?.estado_subasta.slug === "finalizada";
      },
      esGanador(puja) {
        return this.usuarioStore.user?.id === puja.user_ultima_oferta_id;
      },
      puedeElegirCuit(puja) {
        return this.esFinalizada(puja) && this.esGanador(puja);
      },
      puedeMarcarCheckbox(puja) {
        return this.puedeElegirCuit(puja);
      },
      textoAprobacion(puja) {
        const slug = puja.lote.estado_lote.slug;
        if (slug === "vendido") return "APROBADA";
        if (slug === "no-vendido") return "DESAPROBADA";
        if (slug === "en-negociacion" || slug === "subastado")
          return "PENDIENTE";
        return "";
      },
    },
  }
);
